import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TextMaskModule } from 'angular2-text-mask';
import { SharedModule } from '../../../../../../shared/shared.module';
import { CharterScheduleFormComponent } from './charter-schedule.component';
import { MatDialogModule } from '@angular/material/dialog';
import { FullCalendarModule } from '@fullcalendar/angular';
import momentPlugin from '@fullcalendar/moment';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import { SchedulePricingModule } from './schedule-pricing/schedule-pricing.module';
import { CalendarMobileHelpDialogModule } from './calendar-mobile-help-dialog/calendar-mobile-help-dialog.module';
import { CalendarConnectDialogModule } from './calendar-connect-dialog/calendar-connect-dialog.module';
import { HelpDialogModule } from '../../../../../../public/help-dialog/help-dialog.module';

FullCalendarModule.registerPlugins([
  // register FullCalendar plugins
  momentPlugin,
  dayGridPlugin,
  interactionPlugin,
  timeGridPlugin,
  listPlugin,
]);

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    FlexLayoutModule,
    TextMaskModule,
    SharedModule,
    MatDialogModule,
    FullCalendarModule,
    HelpDialogModule,
    MatExpansionModule,
    SchedulePricingModule,
    CalendarMobileHelpDialogModule,
    CalendarConnectDialogModule,
  ],
  declarations: [CharterScheduleFormComponent],
  entryComponents: [],
  exports: [CharterScheduleFormComponent],
  providers: [],
})
export class CharterScheduleFormModule {}
